export default __webpack_public_path__ + "static/media/mpslogo.c4839a83.webp";